
// export const Factory1_Addr = '0xD6ff05a3Ef112A5dc5CCc7216414F61fe79e1095';
//export const Factory1_Addr = '0x79345E43BDf97d81eA9bF103f03791b8Cb5B6E9E'
export const Factory1_Addr = '0xcF1281C9a247A5A63C718A12119DC2b0279834Ff'


// export const Factory2_Addr = '0x5eCAa778B2E7352d83a51148aFB38e1890951192';
// export const Factory2_Addr = "0xaB978c0d00DFff9642b3d6daf46567926C5023D0";
//export const Factory2_Addr = '0x19A6eb42Be73De86204AFe0b2c500189af8E15A4';
export const Factory2_Addr = '0xCf3b95b3edffCE3b4dDcDaA4979767428B7Fbb49';
